export enum BrexTokenErrors {
  INVALID_BREX_TOKEN = 'INVALID_BREX_TOKEN',
  INVALID_BREX_CARD = 'INVALID_BREX_CARD',
  BUDGET_NAME_MISSING = 'BUDGET_NAME_MISSING',
  BUDGET_CURRENCY_MISSING = 'BUDGET_CURRENCY_MISSING',
  BUDGET_CARD_ID_MISSING = 'BUDGET_CARD_ID_MISSING',
}
